<template>
  <section v-if="showTopbar" class="woot-topbar small-12 columns">
    <div class="topbar-brand">
      <logo
        :source="globalConfig.logoThumbnail"
        :name="globalConfig.installationName"
        :account-id="accountId"
      />
      <conversation-list-refresh-indicator />
    </div>

    <search v-if="allowCurrentAccount" />

    <div class="menu user-menu">
      <support
        v-if="globalConfig.chatwootInboxToken"
        @show-support-chat-window="toggleSupportChatWindow"
      />

      <notification-bell
        v-if="allowCurrentAccount"
        :notification-event-key="notificationEventKey"
        @open-notification-panel="openNotificationPanel"
      />
      <div class="notification-popups">
        <notification-popup
          v-for="item in notificationItems"
          :key="item.key"
          :notification="item.notification"
          @close="removeNotification(item.key)"
        />
      </div>
      <alert
        class="alert-user-availability hide-on-mobile"
        :show-title="false"
        :show="showAlertUserAvailability"
        :content="
          $t(`SIDEBAR.ALERT_USER_AVAILABILITY.MESSAGE`, {
            status: availabilityDisplayLabel,
          })
        "
        icon-size="24"
        type="danger"
      />

      <agent-details @toggle-menu="toggleOptions" />

      <options-menu
        :show="showOptionsMenu"
        @toggle-accounts="toggleAccountModal"
        @key-shortcut-modal="$emit('key-shortcut-modal')"
        @close="toggleOptions"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import AgentDetails from './topbarComponents/AgentDetails';
import ConversationListRefreshIndicator from './topbarComponents/ConversationListRefreshIndicator';
import Logo from './topbarComponents/Logo';
import NotificationBell from './topbarComponents/NotificationBell';
import ObserverMode from './topbarComponents/ObserverMode';
import OptionsMenu from './topbarComponents/OptionsMenu';
import PrimaryNavItem from './sidebarComponents/PrimaryNavItem';
import Search from './topbarComponents/Search';
import Support from './topbarComponents/Support';
import Alert from 'shared/components/Alert';
import NotificationPopup from './topbarComponents/NotificationPopup';

import { frontendURL } from 'dashboard/helper/URLHelper';
import wootConstants from 'dashboard/constants/globals';

const { AVAILABILITY_STATUS_KEYS } = wootConstants;

export default {
  components: {
    AgentDetails,
    ConversationListRefreshIndicator,
    Logo,
    NotificationBell,
    ObserverMode,
    OptionsMenu,
    PrimaryNavItem,
    Search,
    Support,
    Alert,
    NotificationPopup,
  },
  data() {
    return {
      showOptionsMenu: false,
      notificationEventKey: 0,
      notificationItems: [],
    };
  },
  mounted() {
    window.bus.$on('notification_created', this.onNotificationCreated);
  },
  beforeDestroy() {
    window.bus.$off('notification_created', this.onNotificationCreated);
  },
  methods: {
    onNotificationCreated(data) {
      this.notificationItems.push({ key: Date.now(), notification: data.notification });
      this.notificationEventKey += 1;
    },
    removeNotification(key) {
      this.notificationItems = this.notificationItems.filter(item => item.key !== key);
    },
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleSupportChatWindow() {
      window.$chatwoot.toggle();
    },
    openNotificationPanel() {
      this.$emit('open-notification-panel');
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    }
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
      isACustomBrandedInstance: 'globalConfig/isACustomBrandedInstance',
      isEmbedding: 'isEmbedding',
      currentRole: 'getCurrentRole',
      currentUserAvailability: 'getCurrentUserAvailability',
      currentUserID: 'getCurrentUserID',
      allowCurrentAccount: 'allowCurrentAccount',
    }),
    docsPath() {
      return frontendURL(`accounts/${this.accountId}/docs`);
    },
    showTopbar() {
      if (this.currentRole == 'embed' || this.isEmbedding) {
        return false;
      }

      return true;
    },
    showAlertUserAvailability() {
      return this.allowCurrentAccount && this.currentUserAvailability !== 'online';
    },
    availabilityDisplayLabel() {
      const availabilityIndex = AVAILABILITY_STATUS_KEYS.findIndex(
        key => key === this.currentUserAvailability
      );
      return this.$t('PROFILE_SETTINGS.FORM.AVAILABILITY.STATUSES_LIST')[
        availabilityIndex
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.woot-topbar {
  background: var(--white);
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: var(--space-micro) solid var(--c-500);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 60px;
  padding: 0 var(--space-normal);
}

.topbar-brand {
  display: flex;
  align-items: center;
  gap: var(--space-small);
}

.user-menu {
  display: flex;
  margin: 0 var(--space-normal);

  @media screen and (max-width: 768px) {
    a {
      display: none;
    }
  }
}

.alert-user-availability {
  margin: var(--space-small);
  white-space: nowrap;
}

.hide-on-mobile {
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.notification-popups {
  position: fixed;
  top: 68px;
  right: var(--space-normal);
  display: flex;
  flex-direction: column;
  gap: var(--space-small);
  z-index: 9999;
}
</style>